var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08227 8.99332H3.36019V21H7.08227V8.99332Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20124 7.42246C6.41192 7.42246 7.40246 6.43191 7.40246 5.21123C7.40246 3.99055 6.42193 3 5.20124 3C3.98056 3 3 3.99055 3 5.21123C3 6.43191 3.98056 7.42246 5.20124 7.42246Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 14.6965C13.0156 13.0056 13.796 12.005 15.2768 12.005C16.6476 12.005 17.2979 12.9655 17.2979 14.6965V21H21V13.3958C21 10.184 19.179 8.62312 16.6276 8.62312C14.0761 8.62312 13.0055 10.6042 13.0055 10.6042V8.98332H9.44355V20.99H13.0055V14.6865L13.0156 14.6965Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.eb0ed721.svg";
export { ForwardRef as ReactComponent };